// extracted by mini-css-extract-plugin
export default {"overlay":"PublishDialog_overlay__auU4b","option":"PublishDialog_option__AXWzD"};